import { Badge } from '../../components/ui/badge';
import { CheckCircle2, Clock, Lock } from 'lucide-react';

export const getStatusBadge = (status) => {
  switch (status) {
    case 'available':
      return <Badge className="bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-400 hover:bg-emerald-100">Available</Badge>;
    case 'soft_blocked':
      return <Badge className="bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-400 hover:bg-amber-100">Blocked</Badge>;
    case 'booked':
      return <Badge className="bg-rose-100 text-rose-700 dark:bg-rose-950 dark:text-rose-400 hover:bg-rose-100">Booked</Badge>;
    case 'sold':
      return <Badge className="bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-400 hover:bg-blue-100">Sold</Badge>;
    case 'on_hold':
      return <Badge className="bg-zinc-100 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-400 hover:bg-zinc-100">On Hold</Badge>;
    default:
      return <Badge variant="secondary">{status}</Badge>;
  }
};

export const getStatusIcon = (status) => {
  switch (status) {
    case 'available':
      return <CheckCircle2 className="w-4 h-4 text-emerald-600" />;
    case 'soft_blocked':
      return <Clock className="w-4 h-4 text-amber-600" />;
    case 'booked':
      return <Lock className="w-4 h-4 text-rose-600" />;
    default:
      return null;
  }
};

export const formatPrice = (price) => {
  if (price >= 10000000) {
    return `₹${(price / 10000000).toFixed(2)} Cr`;
  } else if (price >= 100000) {
    return `₹${(price / 100000).toFixed(2)} L`;
  }
  return `₹${price.toLocaleString('en-IN')}`;
};

export const canChangeStatus = (unit, newStatus, userRole) => {
  if (unit.status === 'booked' && newStatus !== 'available') {
    return userRole === 'admin' || userRole === 'management';
  }
  if (newStatus === 'booked') {
    return userRole !== 'channel_partner';
  }
  return true;
};

export const DEFAULT_COLUMNS = [
  { id: 'project', label: 'Project', visible: true, required: true },
  { id: 'unit', label: 'Unit', visible: true, required: true },
  { id: 'tower', label: 'Tower', visible: true, required: false },
  { id: 'type', label: 'Type', visible: true, required: false },
  { id: 'configuration', label: 'Configuration', visible: true, required: false },
  { id: 'floor', label: 'Floor', visible: true, required: false },
  { id: 'area', label: 'Area', visible: true, required: false },
  { id: 'price', label: 'Price', visible: true, required: false },
  { id: 'status', label: 'Status', visible: true, required: true },
  { id: 'block_expiry', label: 'Block Expiry', visible: true, required: false },
];
